<app-header></app-header>
<div class="our-worlds">
    <p class="title-our-world">Conferencias y Ceremonias</p>
    <div class="line-our-world"></div>

    <!-- Caracteristicas -->
    <div class="our-worlds-container">
        <div class="side-right-ferias">
            <p class="title-side-right-ferias">CARACTERISTICAS</p><br>
            <div class="row">

                <div class="col-12 col-lg-6 padding-ten-right lg-padding-five-right md-padding-15px-right md-margin-five-bottom wow fadeIn border-right border-color-extra-medium-gray text-align-center"
                    style="visibility: visible; animation-name: fadeIn;">


                    <div class="icon-box d-table w-100 mx-auto mx-lg-0 last-paragraph-no-margin">
                        <div class="row">
                            <div class="col-lg-2 element-imp">
                                <img src="../assets/images/icon-p.png">
                            </div>
                            <div
                                class="col-lg-10 icon-box-holder align-middle d-table-cell position-relative paddin-10">
                                <div class="txt-align-caracteristicas"><b>Inmersividad:</b> Esta característica se logra
                                    mediante una fusión sin precedentes entre lo virtual y lo físico. </div>
                                <br><br>
                            </div>
                        </div>
                    </div>
                    <div class="icon-box d-table w-100 mx-auto mx-lg-0 last-paragraph-no-margin">
                        <div class="row">
                            <div class="col-lg-2 element-imp">
                                <img src="../assets/images/icon-p.png">
                            </div>
                            <div
                                class="col-lg-10 icon-box-holder align-middle d-table-cell position-relative paddin-10">
                                <div class="txt-align-caracteristicas"><b>Conectividad:</b> Conecta multitud de
                                    aplicaciones y servicios. </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-12 col-lg-6 padding-ten-left lg-padding-five-left md-padding-15px-left md-margin-five-bottom wow fadeIn"
                    style="visibility: visible; animation-name: fadeIn;">
                    <div class="icon-box d-table w-100 mx-auto mx-lg-0 last-paragraph-no-margin">
                        <div class="row">
                            <div class="col-lg-2 element-imp">
                                <img src="../assets/images/icon-p.png">
                            </div>
                            <div
                                class="col-lg-10 icon-box-holder align-middle d-table-cell position-relative paddin-10">
                                <div class="txt-align-caracteristicas"><b>Sincronicidad:</b> Los participantes
                                    tendrán capacidad de interactuar entre sí y con el mundo digital en tiempo real.
                                </div>
                                <br>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-lg-2 element-imp">
                                <img src="../assets/images/icon-p.png">
                            </div>
                            <div
                                class="col-lg-10 icon-box-holder align-middle d-table-cell position-relative paddin-10">
                                <div class="txt-align-caracteristicas"><b>Disponibilidad:</b> Todo el mundo
                                    podrá conectarse simultáneamente y no habrá límite en el número de participantes
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <!-- Fin característica -->

    <!-- Beneficios -->
    <div class="our-worlds-container">
        <div class="side-right-ferias">
            <p class="title-side-right-ferias">BENEFICIOS</p>
            <p class="description-side-right-ferias">
                Ofrezca toda una experiencia inmersiva e interactiva. Ideal para los amantes de la tecnología.
            </p>
            <div class="row">
                <div class="col-12 col-lg-4 col-md-6 text-center"
                    style="visibility: visible; animation-name: fadeInUp;">
                    <img class="img-fondo" src="../assets/images/ok.png" width="50px" height="50px"><br><br>
                    <div class="txt-align-beneficios">Se requiere de menor tiempo para organizar el evento</div>
                </div>
                <!-- end service item -->
                <!-- start service item -->
                <div class="col-12 col-lg-4 col-md-6 text-center" data-wow-delay="0.2s"
                    style="visibility: visible; animation-delay: 0.2s; animation-name: fadeInUp;">
                    <img class="img-fondo" src="../assets/images/ok.png" width="50px" height="50px"><br><br>
                    <div class="txt-align-beneficios">Reducción
                        significativa en gastos y costos del evento</div>
                </div>
                <!-- end service item -->
                <!-- start service item -->
                <div class="col-12 col-lg-4 col-md-6 text-center">
                    <img class="img-fondo" src="../assets/images/ok.png" width="50px" height="50px"><br><br>
                    <div class="txt-align-beneficios">Permite crear un
                        conferencia o celebración global</div><br>
                </div>
                <!-- end service item -->
                <!-- start service item -->
                <div class="col-12 col-lg-4 col-md-6 text-center">
                    <img class="img-fondo" src="../assets/images/ok.png" width="50px" height="50px"><br><br>
                    <div class="txt-align-beneficios">
                        Independientemente del tamaño de la empresa, es de fácil acceso por el costo</div><br>
                </div>
                <!-- end service item -->
                <!-- start service item -->
                <div class="col-12 col-lg-4 col-md-6 text-center">
                    <img class="img-fondo" src="../assets/images/ok.png" width="50px" height="50px"><br><br>
                    <div class="txt-align-beneficios">Engagement con la audiencia y recordación de la marca</div>

                </div>
                <!-- end service item -->
                <!-- start service item -->
                <div class="col-12 col-lg-4 col-md-6 text-center">
                    <img class="img-fondo" src="../assets/images/ok.png" width="50px" height="50px"><br><br>
                    <div class="txt-align-beneficios">Se puede obtener
                        feedback en tiempo real</div><br>
                </div>
                <!-- end service item -->
                <!-- start service item -->

                <div class="col-12 col-lg-12 col-md-6 text-center">
                    <img class="img-fondo" src="../assets/images/ok.png" width="50px" height="50px"><br><br>
                    <div class="txt-align-beneficios">Data que permite
                        realizar indicadores para medir el éxito del evento</div>
                </div>
            </div>
        </div>
    </div>
    <!-- Fin beneficios -->

    <!-- Funcionalidades -->
    <div class="our-worlds-container">
        <div class="side-right-ferias">
            <p class="title-side-right-ferias">Funcionalidades</p>
            <br>
            <div class="row">
                <!-- start service item -->
                <div class="col-12 col-lg-4 col-md-6 text-center">
                    <img src="../assets/images/funcionalidades.png" width="50px" height="50px"><br><br>
                    <div class="txt-align-beneficios">Dominio personalizado. </div><br><br>
                </div>
                <!-- end service item -->
                <!-- start service item -->
                <div class="col-12 col-lg-4 col-md-6 text-center">
                    <img src="../assets/images/funcionalidades.png" width="50px" height="50px"><br><br>
                    <div class="txt-align-beneficios">Diseño customizado, tanto de la disposición de la sala como de lo
                        visual.
                    </div><br>
                </div>
                <!-- end service item -->
                <!-- start service item -->
                <div class="col-12 col-lg-4 col-md-6 text-center">
                    <img src="../assets/images/funcionalidades.png" width="50px" height="50px"><br><br>
                    <div class="txt-align-beneficios">Diseño responsivo. </div>

                </div>
                <!-- end service item -->
                <!-- start service item -->
                <div class="col-12 col-lg-4 col-md-6 text-center">
                    <img src="../assets/images/funcionalidades.png" width="50px" height="50px"><br><br>
                    <div class="txt-align-beneficios">Definición del público asistente, puede ser público o listado
                        privado. </div><br>
                </div>
                <!-- end service item -->
                <!-- start service item -->

                <div class="col-12 col-lg-4 col-md-6 text-center">
                    <img src="../assets/images/funcionalidades.png" width="50px" height="50px"><br><br>
                    <div class="txt-align-beneficios">Configuración a la medida, previamente se puede asignar la
                        ubicación, en mesas o zonas. </div>
                </div>

                <div class="col-12 col-lg-4 col-md-6 text-center">
                    <img src="../assets/images/funcionalidades.png" width="50px" height="50px"><br><br>
                    <div class="txt-align-beneficios">Control de acceso a la conferencia o ceremonia. </div>
                </div>

                <div class="col-12 col-lg-4 col-md-6 text-center">
                    <img src="../assets/images/funcionalidades.png" width="50px" height="50px"><br><br>
                    <div class="txt-align-beneficios">Opción de tener un moderador, quién puede activar o desactivar
                        audio, video, compartir pantalla, el avatar puede tener la foto de la persona que se defina, en
                        un recuadro. </div>
                </div>
            </div>
        </div>
    </div>
    <!-- Fin funcionalidades -->
</div>

<app-footer></app-footer>